export const buildLightboxImage = (src, caption) => ({src, caption});
